import { useMemo, useState } from "react";
import { ArrowDown, ArrowUp, ArrowUpDown } from "lucide-react";

const cmp = (a, b) => {
  const na = a === null || a === undefined || a === "", nb = b === null || b === undefined || b === "";
  if (na || nb) return na && nb ? 0 : na ? 1 : -1;
  if (typeof a === "number" && typeof b === "number") return a - b;
  if (typeof a === "boolean" || typeof b === "boolean") return (a ? 1 : 0) - (b ? 1 : 0);
  return String(a).localeCompare(String(b), "it", { numeric: true, sensitivity: "base" });
};

// accessors: { key: row => value }; returns sorted rows and a header-cell renderer
export function useSort(rows, accessors, init = {}) {
  const [s, setS] = useState({ key: init.key || null, dir: init.dir || "asc" });
  const sorted = useMemo(() => {
    if (!rows || !s.key || !accessors[s.key]) return rows;
    const get = accessors[s.key];
    const out = [...rows].sort((x, y) => {
      const a = get(x), b = get(y);
      const empty = (v) => v === null || v === undefined || v === "";
      if (empty(a) || empty(b)) return cmp(a, b);
      return s.dir === "asc" ? cmp(a, b) : cmp(b, a);
    });
    return out;
  }, [rows, s, accessors]);
  const toggle = (key) => setS((p) => (p.key === key ? { key, dir: p.dir === "asc" ? "desc" : "asc" } : { key, dir: init.firstDir?.[key] || "asc" }));
  const Th = ({ k, children, className = "", testid }) => {
    const on = s.key === k;
    const Icon = !on ? ArrowUpDown : s.dir === "asc" ? ArrowUp : ArrowDown;
    return (
      <th className={`p-3 ${className}`} aria-sort={on ? (s.dir === "asc" ? "ascending" : "descending") : "none"}>
        <button type="button" data-testid={testid || `sort-${k}`} onClick={() => toggle(k)}
          className={`inline-flex items-center gap-1 uppercase font-mono text-[11px] whitespace-nowrap hover:text-brand-navy ${on ? "text-brand-navy font-bold" : ""}`}>
          {children} <Icon className={`w-3 h-3 ${on ? "" : "opacity-40"}`} />
        </button>
      </th>
    );
  };
  return { rows: sorted, Th, sort: s, setSort: setS };
}

export function SortSelect({ options, sort, setSort, testid }) {
  return (
    <div className="flex items-center gap-1 text-xs text-slate-500">
      Ordina per
      <select data-testid={`${testid}-key`} value={sort.key || ""} onChange={(e) => setSort({ ...sort, key: e.target.value })} className="h-8 px-2 rounded-md border border-slate-200 bg-white text-sm text-slate-800">
        {options.map(([k, l]) => <option key={k} value={k}>{l}</option>)}
      </select>
      <button type="button" data-testid={`${testid}-dir`} onClick={() => setSort({ ...sort, dir: sort.dir === "asc" ? "desc" : "asc" })} className="press h-8 px-2 rounded-md border border-slate-200 bg-white inline-flex items-center gap-1 text-slate-800">
        {sort.dir === "asc" ? <ArrowUp className="w-3.5 h-3.5" /> : <ArrowDown className="w-3.5 h-3.5" />} {sort.dir === "asc" ? "Crescente" : "Decrescente"}
      </button>
    </div>
  );
}
